import React from 'react';
import clsx from 'clsx';

import CurrentStatus from 'components/atoms/CurrentStatus';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  functionWrap: {
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'space-around',
    alignItems: 'center',
    minHeight: 50,
    maxHeight: 52,
    padding: '5px 15px',
    boxSizing: 'border-box',
    marginBottom: 20,
    backgroundColor: '#f6f6f9',
    borderRadius: '4px',
    '& > div': {
      margin: '4px 7px 4px 0',
    },
  },
}));

/**
 * 필터 영역 외에 들어가는 기능버튼(등록, 수정, 삭제 등)에 대한 영역을 잡아주는 컴포넌트
 * @param props
 * @returns {*}
 * @constructor
 */
const FunctionWrap = (props) => {
  const { children, loading = true, style } = props;
  const classes = useStyles();
  return (
    <div className={clsx(classes.functionWrap)} style={style}>
      {loading ? <CurrentStatus /> : children}
    </div>
  );
};

export default FunctionWrap;
